export const Projects = (() => {
	'use strict';

	function init() {
			
		var $project = $('.project');
		var $dropdown = $('#filtering-dropdown');
		
		$dropdown.on('change',function(){

		var type = $(this).val();

			if(type== '' ){
				$project.show();
			}
			else {
				$project.hide();
				$('.project[data-type*="'+type+'"]').show();

			}
			

		})
		// $dropdown.click(function(){
		// 	console.log($this(value));
		// })

		
	
			
	
		
		
	}

	return {
		init: init,
		name: 'projects'
	};
})();
